<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>分步模板管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <template>
        <a href="http://oss-cn-hangzhou.aliyuncs.com/sjpublicdev/191014/1/6e514eb94e4d9e648a06b4d09cb18c1a.pdf"
           target="_blank"
           style="position:absolute;right:10px;bottom:18px"
        >标准模板使用说明
        </a>
      </template>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               clearable
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="关键字"
                        prop="keyword"
          >
            <el-input placeholder="请输入关键字"
                      v-model="search.keyword"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="创建人"
                        prop="createName"
          >
            <el-input placeholder="请输入创建人"
                      v-model="search.createName"
                      clearable>

            </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="mini"
                     native-type="submit">搜索
          </el-button>
          <!--<el-button icon="sj-icon-export"-->
          <!--@click="onExportSearch()">导出-->
          <!--</el-button>-->
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <!--<el-button type="primary"-->
        <!--size="small"-->
        <!--icon="sj-icon-export"-->
        <!--@click="onExportPage()"></el-button>-->
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <!--   区分正常与查理宝分步模版创建    -->
        <router-link :to="$route.params.type === '20' ? '/clb-step-template/create' : '/step-template/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
        <router-link v-permission="35002"
                     :to="'/audio-asr-check/template'"
                     style="margin-left: 8px;">
          <el-button size="small">录音风险配置
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="分步模板ID"></el-table-column>
        <el-table-column prop="title"
                         label="标题"
                         min-width="120"></el-table-column>
        <el-table-column prop="detail"
                         label="描述"
                         min-width="180">
          <template slot-scope="scope">
            <div style="white-space: pre-wrap;">{{ scope.row.detail }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="total"
                         label="步数">
        </el-table-column>

        <el-table-column prop="adminname"
                         label="创建人">
          <template slot-scope="scope">
            <span v-if="scope.row.adminid==null">系统创建</span>
            <span v-else>{{scope.row.adminname}}</span>
          </template>


        </el-table-column>

        <el-table-column prop="createtime"
                         label="创建时间"
                         min-width="180">
          <template slot-scope="scope">
            {{formatDate(scope.row.createtime)}}
          </template>
        </el-table-column>
        <el-table-column prop="updatetime"
                         label="更新时间"
                         min-width="180">
          <template slot-scope="scope">

            <span @click="openVisibleLogDialog(scope.row.id)">{{formatDate(scope.row.updatetime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="audio_asr_check_template_title"
                         label="录音风险配置"
                         min-width="220"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <router-link v-if="Number(scope.row.audio_asr_check_template_id) > 0"
                         :to="`/audio-asr-check/template/update/${scope.row.audio_asr_check_template_id}`"
                         class="step-template-asr-config-link"
                         target="_blank">
              <el-link type="primary">{{ formatAsrConfigLabel(scope.row) }}</el-link>
            </router-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="330">
          <template slot-scope="scope">
            <router-link :to="$route.params.type ? `/clb-step-template/update/${scope.row.id}` : `/step-template/update/${scope.row.id}`">
              <el-button size="mini"
                         type="primary">
                <span v-if="['', users.id].includes(scope.row.adminid) || parseInt(users.usertype) === 1">
                  修改
                </span>
                <span v-else>
                  查看
                </span>
              </el-button>
            </router-link>
            <el-button size="mini"
                       type="primary"
                       @click="onCopy(scope.row.id)"
            >
              复制
            </el-button>

            <el-button size="mini"
                       type="danger"
                       @click="onDelete(scope.row.id)">
              删除
            </el-button>

            <el-button size="mini"
                       v-permission="35002"
                       type="warning"
                       @click="openAsrBindDialog(scope.row)">录音风险配置
            </el-button>

            <el-button size="mini"
                       v-permission="211"
                       style="margin: 10px;"
                       type="info"
                       @click="onBatchUpdateTask(scope.row.id)">批量更新任务
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <step-template-log :visible.sync="visibleLogDialog"
                       :id="stepTemplateId"/>
    <step-template-asr-bind-dialog
      :visible.sync="asrBindDialogVisible"
      :substep-id="asrBindRow && asrBindRow.id"
      :row-title="asrBindRow && asrBindRow.title"
      @success="onRefresh"/>
  </div>
</template>

<script>
import { searchRules } from '../step-template.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'
import StepTemplateLog from '@/views/step-template/components/StepTemplateLog'
import StepTemplateAsrBindDialog from '@/views/step-template/components/StepTemplateAsrBindDialog'

export default {
  components: {StepTemplateLog, StepTemplateAsrBindDialog},
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        keyword: null,
        createName: null,
        type: this.$route.params.type || 0, // 分步模板类型
      },
      visibleLogDialog: false,
      stepTemplateId: null,
      asrBindDialogVisible: false,
      asrBindRow: null,
      exportHeader: [
        {
          key: 'id',
          text: '分步模板ID',
        },
        {
          key: 'name',
          text: '分步模板名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    users: state => state.login.user,
  }),
  created () {
    console.log(this.users)
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getStepTemplateTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('getStepTemplateTable', params),
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportStepTemplateData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteStepTemplateData', {id: id}).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    onCopy (id) {
      request.common('copyStepTemplateData', {id: id}).then(() => {
        this.$message.success('复制成功')
        this.onSearch()
      })
    },
    onBatchUpdateTask (id) {
      this.$confirm('确认批量更新?', '提示', {type: 'warning'}).then(() => {
        let detail = {
          displayName: '模板ID',
          taskType: 234,
          file_type: 9,
          collection_type: 2,
          id: id,
        }
        request.common('createExecuteTaskBatch', detail).then(() => {
          this.$message.success('批量更新成功,请前往批量任务查看')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    formatDate (value) {
      return filter.formatUnix(value)
    },
    formatAsrConfigLabel (row) {
      if (!row) {
        return '-'
      }
      const title = row.audio_asr_check_template_title == null || row.audio_asr_check_template_title === ''
        ? ''
        : String(row.audio_asr_check_template_title)
      const id = row.audio_asr_check_template_id == null || Number(row.audio_asr_check_template_id) === 0
        ? ''
        : String(row.audio_asr_check_template_id)
      if (title && id) {
        return `${title} / ${id}`
      }
      return title || id || '-'
    },
    openVisibleLogDialog (id) {
      this.visibleLogDialog = true
      this.stepTemplateId = id
    },
    openAsrBindDialog (row) {
      this.asrBindRow = row
      this.asrBindDialogVisible = true
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.step-template-asr-config-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;

  ::v-deep .el-link {
    display: inline;
    font-size: inherit;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/pages/StepTemplateTable.vue